import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';

export class Filtro {
  text: string;
  badge: number;
  action: any;
  active: boolean;
  constructor(text: string, badge: number, action: any, active: boolean) {
    this.text = text;
    this.badge = badge;
    this.action = action;
    this.active = active;
  }

  toggle() {
    this.active = !this.active;
  }
}

@Injectable({
  providedIn: 'root',
})
export class TableFilterService {
  filters$ = new BehaviorSubject<Filtro[]>(null);

  active = 0;

  constructor(private toastr: ToastrService) {}

  get filters() {
    return this.filters$.value;
  }

  set filters(val) {
    this.active = 0;
    this.filters$.next(val);
  }

  enable(idx) {
    const updated = this.filters;
    if (!updated) return;
    try {
      updated[this.active].active = false;
      updated[idx].active = true;
      this.active = idx;
      this.filters$.next(updated);
    } catch (err) {
      this.toastr.error('Table Filter');
    }
  }
}
